module.exports = __webpack_public_path__ + "static/fonts/SFProDisplay-Black.65cc69d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/SFProDisplay-Black/SFProDisplay-Black.woff
// module id = CA9s
// module chunks = 24